import GrandLayout from '../../layouts/GrandLayout/GrandLayout';
import GrandPageAnimatedSections from '../../features/GrandPage/GrandPageAnimatedSections/GrandPageAnimatedSections';

export default function GrandPage() {
   


    return (
        <GrandLayout
        >
            <GrandPageAnimatedSections/>
        </GrandLayout>

    )
}